Ext.define('SA.model.NormalizedLocationBuilder', {
    statics: {
        create(params) {
            return new SA.model.NormalizedLocationBuilder(params);
        },

        forCombo() {
            return this.create({type: 'combination'});
        },

        forRadius() {
            return this.create({type: 'radius'});
        },

        forSeries() {
            return this.create({type: 'locationSeries'});
        }
    },

    constructor({type}) {
        this.params = {type};
    },

    build() {
        var {type, stringId, locationSeries, radiusSizeInMeters = 0} = this.params;

        return {
            type,
            id: stringId,
            isNormalized: true,
            locationSeries: Ext.Array.from(locationSeries),
            radius: radiusSizeInMeters,
            geographicUnit: undefined 
        };
    },

    locationSeries(locationSeries) {
        return this.setParam({locationSeries});
    },

    radiusSizeInMeters(radiusSizeInMeters) {
        return this.setParam({radiusSizeInMeters});
    },

    setParam(param) {
        Object.assign(this.params, param);
        return this;
    },

    stringId(stringId) {
        return this.setParam({stringId});
    }
});